export interface CatalogueEntry {
  key: string
  label: string
  source: string
  runnable: boolean
  /** Why it cannot be run from here, when it cannot. */
  note: string | null
}

export interface DatasetColumnView {
  key: string
  label: string
  type: string
  groupable: boolean
}

export interface DatasetView {
  key: string
  label: string
  columns: DatasetColumnView[]
  personal: boolean
  /** Says that running it is recorded, so nobody is surprised by the access log. */
  personalDataNote: string | null
}

export interface FilterSpec {
  column: string
  operator: string
  value: string | null
}

export interface ReportDefinition {
  columns: string[]
  filters: FilterSpec[]
  groupBy: string[]
  orderBy: string | null
  orderDescending: boolean
  limit: number | null
}

export interface ReportRunResult {
  label: string
  columns: string[]
  rows: unknown[][]
  rowCount: number
  /** What the run actually asked. Shown, because a wrong report is unarguable with it. */
  resolvedSql: string
  truncated: boolean
  truncationNote: string | null
}

export interface SavedReportView {
  id: string
  name: string
  description: string | null
  sourceKind: string
  sourceKey: string
  definition: ReportDefinition
  defaultFormat: string
  ownerUserId: string | null
  ownerName: string | null
  sharing: string
  sharedRoleIds: string[]
  active: boolean
  lastRunAt: string | null
  lastRowCount: number | null
}

export interface RunLogView {
  id: string
  savedReportId: string | null
  sourceKey: string | null
  runBy: string | null
  runByName: string | null
  runAt: string
  format: string | null
  rowCount: number | null
  durationMs: number | null
}

export const OPERATOR_LABEL: Record<string, string> = {
  EQ: 'is',
  NE: 'is not',
  CONTAINS: 'contains',
  GT: 'is after / more than',
  GTE: 'is at least',
  LT: 'is before / less than',
  LTE: 'is at most',
  IS_NULL: 'is empty',
  IS_NOT_NULL: 'is not empty',
}

export const SOURCE_LABEL: Record<string, string> = {
  BUILT_IN: 'Built in',
  DATASET: 'Builder',
  BI_VIEW: 'BI view',
}
